// plugins/loading.js
import { showLoading, closeLoading,showLoadingByWenzi } from '@/plugins/loadingFun';

export default {
  install: (app, options) => {
    app.provide('$loading', {
      show: showLoading,
      close: closeLoading
    });
  }
};